(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("WorkingHoursController", WorkingHoursController);

  /** @ngInject */
  function WorkingHoursController(
    deviceActions,
    $scope,
    $state,
    $stateParams,
    layoutActions
  ) {
    var vm = this;

    vm.workingHoursData = {
      alwaysOpen: false,
      closedByMerchant: false,
      days: [
        {
          day: 0,
          hoursFrom: null,
          minutesFrom: null,
          hoursTo: null,
          minutesTo: null,
          state24h: "NONE"
        },
        {
          day: 1,
          hoursFrom: null,
          minutesFrom: null,
          hoursTo: null,
          minutesTo: null,
          state24h: "NONE"
        },
        {
          day: 2,
          hoursFrom: null,
          minutesFrom: null,
          hoursTo: null,
          minutesTo: null,
          state24h: "NONE"
        },
        {
          day: 3,
          hoursFrom: null,
          minutesFrom: null,
          hoursTo: null,
          minutesTo: null,
          state24h: "NONE"
        },
        {
          day: 4,
          hoursFrom: null,
          minutesFrom: null,
          hoursTo: null,
          minutesTo: null,
          state24h: "NONE"
        },
        {
          day: 5,
          hoursFrom: null,
          minutesFrom: null,
          hoursTo: null,
          minutesTo: null,
          state24h: "NONE"
        },
        {
          day: 6,
          hoursFrom: null,
          minutesFrom: null,
          hoursTo: null,
          minutesTo: null,
          state24h: "NONE"
        }
      ]
    };

    vm.dayStateOptions = [
      { value: "NONE", label: "WORKING_HOURS_CUSTOM" },
      { value: "OPEN", label: "OPENED_24" },
      { value: "CLOSE", label: "CLOSED_24" }
    ];

    vm.isDayCustom = function(dayIndex) {
      return vm.workingHoursData.days[dayIndex].state24h === "NONE";
    };

    vm.cancelChanges = function () {
      goToDetailsPage($stateParams.id);
    };

    vm.saveChanges = function (workingHoursData) {
      layoutActions.showLoader();
      deviceActions
        .updateDeviceWorkingHours($stateParams.pointId, workingHoursData)
        .then(
          function () {
            init();
          },
          function () {
            //todo error handling
          }
        );
    };

    vm.changeType = function (workingHoursType) {
      switch (true) {
        case workingHoursType === "WH_ALWAYS_OPEN":
          vm.workingHoursData.alwaysOpen = true;
          vm.workingHoursData.closedByMerchant = false;
          vm.disableCustomWorkingHours = true;
          break;
        case workingHoursType === "WH_ALWAYS_CLOSE":
          vm.workingHoursData.closedByMerchant = true;
          vm.workingHoursData.alwaysOpen = false;
          vm.disableCustomWorkingHours = true;
          break;
        default:
          vm.workingHoursData.alwaysOpen = false;
          vm.workingHoursData.closedByMerchant = false;
          vm.disableCustomWorkingHours = false;
          break;
      }
    };

    function init() {
      layoutActions.showLoader();
      deviceActions
        .getDeviceWorkingHours($stateParams.pointId)
        .then(function (workingHoursDto) {
          layoutActions.hideLoader();
          vm.workingHoursData = workingHoursDto;
          switch (true) {
            case workingHoursDto.alwaysOpen:
              vm.workingHoursSelector = "WH_ALWAYS_OPEN";
              vm.disableCustomWorkingHours = true;
              break;
            case workingHoursDto.closedByMerchant:
              vm.workingHoursSelector = "WH_ALWAYS_CLOSE";
              vm.disableCustomWorkingHours = true;
              break;
            default:
              vm.workingHoursSelector = "WH_CUSTOM";
              vm.disableCustomWorkingHours = false;
              break;
          }
        });

      $scope.$on("$destroy", function () {});
    }

    init();

    function goToDetailsPage(deviceSerial) {
      $state.go("app.dashboardTechnology.facilityDetails", {
        id: deviceSerial
      });
    }
  }
})();
